import PropTypes from 'prop-types';
import styles from './FJTitleLine.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJDropdownNew from '../../components/FJDropDown/FJDropdownNew.jsx';
import FJHelpIcon from '../../../assets/svg/help.svg?react';

const FJTitleLine = props => {
    const {
        title,
        desc,
        isRequire = false,
        isShowHelp = true,
        renderRight = () => {},
        isShowTry = true,
        onUseSample = () => {},
        style,
    } = props;

    const _renderTrigger = config => {
        return (
            <div className={styles.icon} onClick={config.onClick} ref={config.ref}>
                <FJHelpIcon />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.desc} ref={config.ref}>
                {desc}
            </div>
        );
    };

    return (
        <div className={styles.box} style={style}>
            <div className={styles.left}>
                <div className={classNames(styles.title, isRequire ? styles.is_require : '')}>{title}</div>
                {isShowHelp && (
                    <FJDropdownNew
                        isTopLayer={true}
                        renderTrigger={_renderTrigger}
                        useAnchorBody
                        placement='rightTop'
                        trigger='click'
                        renderOverlay={_renderOverlay}
                        offsetLeft={8}
                        offsetTop={-11}
                    />
                )}
            </div>
            {isShowTry && (
                <div className={styles.try} onClick={onUseSample}>
                    {FJLocalStore._('try-sample')}
                </div>
            )}
            {renderRight()}
        </div>
    );
};

FJTitleLine.propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
    isRequire: PropTypes.bool,
    isShowHelp: PropTypes.bool,
    isShowTry: PropTypes.bool,
    renderRight: PropTypes.func,
    onUseSample: PropTypes.func,
    style: PropTypes.object,
};

export default FJTitleLine;
